import type { ElementType } from 'react';
import {
  HomeIcon,
  FolderIcon,
  UsersIcon,
  InboxIcon,
  BeakerIcon,
  SparklesIcon,
  DocumentIcon,
  Cog6ToothIcon,
  ArrowPathIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ListBulletIcon,
} from '@heroicons/react/24/outline';

export const navigationIcons: Record<string, ElementType> = {
  home: HomeIcon,
  sources: FolderIcon,
  personas: UsersIcon,
  content: InboxIcon,
  playground: BeakerIcon,
  'persona-studio': SparklesIcon,
  document: DocumentIcon,
  settings: Cog6ToothIcon,
  'arrow-path': ArrowPathIcon,
  'chart-bar': ChartBarIcon,
  chat: ChatBubbleLeftRightIcon,
  list: ListBulletIcon,
  inbox: InboxIcon,
};
